import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-billshistory',
  templateUrl: './billshistory.component.html',
  styleUrls: ['./billshistory.component.sass']
})
export class BillsHistoryComponent implements OnInit {
  public data;
  public tabActive='Pagos y Facturas';
  public empleados=[];
  public banlist;
  public year;
  public format;
  public invoices=[];
  public selectBan;
  public selectYear;
  public yearList=[];
  public companyName;
  constructor(public appComponent:AppComponent,private loadingScreenService :LoadingScreenService ,private services: Service,private global:GlobalService,public AngularFireAnalytics:AngularFireAnalytics){
    this.AngularFireAnalytics.setCurrentScreen("Descarga Tu Factura");
    this.AngularFireAnalytics.logEvent("Descarga Tu Factura-Screenview");
  }
              
  ngOnInit(){
    if(this.global.validateSession()==true){
      this.banlist=JSON.parse(atob(sessionStorage.getItem("getAcoout"))).accounts.AccountList;
      this.year= new Date().getFullYear();
      this.format="pdf";
      this.currentYear();
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
      this.updateBills();
      this.companyName=atob(sessionStorage.getItem("companyName"));
    }
  }
  updateBillsChange(){
    this.global.validateSession();
    sessionStorage.setItem("selectBan",btoa(this.selectBan));
    this.updateBills();
  }
  currentYear(){
    this.year = new Date();
    var anio = this.year.getFullYear();
    for (var i = 0; i <2; i++) {
      this.yearList[i] = anio-i;
    }
    this.selectYear=anio;
 }
  updateBills(){
    this.loadingScreenService.startLoading();
    this.services.getHistoricoFacturas(sessionStorage.getItem("token"),this.selectBan,this.selectYear,this.format).subscribe(data =>{
      this.loadingScreenService.stopLoading();
        if(data.HasError ==false){
          sessionStorage.setItem("getHistoricoFacturas",btoa(JSON.stringify(data)));
          this.invoices=JSON.parse(atob(sessionStorage.getItem("getHistoricoFacturas"))).Invoices;
        }
        else{
          this.loadingScreenService.stopLoading();
          this.global.notif(data.ErrorDesc);
        }
    });
  }
  openPDF(key, billDate) {
    if (this.global.isMobile() != null) {//daniel
      this.loadingScreenService.startLoading();
      this.services.getHistoricalInvoiceOnDemand(sessionStorage.getItem("token"), this.selectBan, key).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.hasError == false) {
          var bin = atob(data.binaryData);
          var obj = document.createElement('object');
          obj.style.width = '100%';
          obj.style.height = '842pt';
          obj.type = 'application/pdf';
          obj.data = 'data:application/pdf;base64,' + data.binaryData;
          var link = document.createElement('a');
          link.download = 'bill' + billDate + '.pdf';
          link.href = 'data:application/octet-stream;base64,' + data.binaryData;
          document.body.appendChild(link);
          link.click();
        }
      });
    }
    else {
      this.loadingScreenService.startLoading();
      this.services.getHistoricalInvoiceOnDemand(sessionStorage.getItem("token"), this.selectBan, key).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.hasError == false) {

          var byteCharacters = atob(data.binaryData);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: 'application/pdf;base64' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
         
        }
      });
    }
  }
  openCVS(key, billDate) {
    this.loadingScreenService.startLoading();
    this.services.getHistoricalInvoiceOnDemand(sessionStorage.getItem("token"), this.selectBan, key).subscribe(data => {
      this.loadingScreenService.stopLoading();
      if (data.hasError == false) {
        let csvContent = atob(data.binaryData);
        var blob = new Blob([csvContent], { type: "data:application/octet-stream;base64" });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = 'bill' + billDate + '.csv';
        document.body.appendChild(a);
        a.click();
      }
    })
  }
}